import Icon from 'flarum/common/components/Icon';
export default function icon(name, attrs) {
  if (attrs === void 0) {
    attrs = {};
  }
  return m(Icon, Object.assign({
    name: name
  }, attrs));
}
flarum.reg.add('v17development-blog', 'common/helpers/icon', icon);